module.exports = __webpack_public_path__ + "static/media/user-icon.18529532.svg";